export default superclass => class extends superclass {
  // Define output string when we cast object to string.
  toString () {
    return `${this.code || this.primaryVal} - ${this.name}`
  }
}
